<script>
	import { googleRecaptchaSiteKey } from "../../../store";

    import {
        FormGroup,
        Container,
        Row,
        Col
    } from "sveltestrap";
</script>


<FormGroup>
    <Container>
        <Row>
            <Col></Col>
            <Col>
                <div class="g-recaptcha" data-sitekey="{googleRecaptchaSiteKey}"></div>
            </Col>
            <Col></Col>
        </Row>
    </Container>
</FormGroup>